// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609212134/js/" + chunkId + "." + {"44":"24fc22f0","225":"56865d76","481":"42d2f17b","486":"eb87899f","770":"70ad3ffb"}[chunkId] + ".0.7949023826120347.chunk.js";
};